import React from 'react';

// Components
import InputWrapper from '../InputWrapper';

type CommonProps = {
  label?: string;
  error?: React.ReactNode;
  isMandatory?: boolean;
  customClassName?: string;
};

type SingleLineProps = React.InputHTMLAttributes<HTMLInputElement> & {
  multiline?: false;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
};

type MultiLineProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  multiline: true;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  onFocus?: React.FocusEventHandler<HTMLTextAreaElement>;
};

type Props = CommonProps & (SingleLineProps | MultiLineProps);

const Input: React.FC<Props> = (props) => {
  if (props.multiline === true) {
    const { label, error, isMandatory, customClassName, multiline: _multiline, className, ...rest } = props;

    void _multiline;

    return (
      <InputWrapper label={label} error={error} isMandatory={isMandatory}>
        <textarea
          className={`input-wrapper__input form-control ${error ? 'input-wrapper__input--error' : ''} ${
            customClassName ? customClassName : ''
          } ${className ?? ''}`}
          {...rest}
        />
      </InputWrapper>
    );
  }

  const { label, error, isMandatory, customClassName, multiline: _multiline, className, ...rest } = props;

  void _multiline;

  return (
    <InputWrapper label={label} error={error} isMandatory={isMandatory}>
      <input
        className={`input-wrapper__input form-control ${error ? 'input-wrapper__input--error' : ''} ${
          customClassName ? customClassName : ''
        } ${className ?? ''}`}
        {...rest}
      />
    </InputWrapper>
  );
};

export default Input;
